import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'Contrato'

const Get = (contractId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${contractId}`, data, config)
const GetAll = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${companyId}/contratos`, data, config)
const GetSubsidiaries = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${companyId}/filiais`)
const GetClassif = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/classif`, data, config)
const SaveClassif = (contractId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/classif/${contractId}`, data, config)
const Archive = (pciID, department, type, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/${pciID}?departamento=${department}&tipo=${type}`)

const ContractsRepository = {
  Get,
  GetAll,
  GetSubsidiaries,
  GetClassif,
  SaveClassif,
  Archive
}

export default ContractsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/contract.js